import React from "react";
import { FormHelperText, InputLabel, MenuItem, Select as MuiSelect } from "@material-ui/core";
import { Controller, useFormContext } from "react-hook-form";
import { SelectOptions } from "hooks";
import { FormControl } from "components";

// TODO: temporary interface, should be generic
interface SelectProps {
    flex?: number;
    // eslint-disable-next-line
    defaultValue?: any;
    name: string;
    disableMargin?: boolean;
    hasEmptyOption?: boolean;
    multiple?: boolean;
    error?: FieldError;
    value?: unknown;
    disabled?: boolean;
    title: string;
    options: SelectOptions[];
    // eslint-disable-next-line
    onChange?: (onChange: (...event: any[]) => void, value: any) => void;
}

/**
 * Select wrapper
 * @param flex Select size
 * @param name Field identifier
 * @param title Field title
 * @param disableMargin disable optional margin
 * @param hasEmptyOption Defines if select has empty option
 * @param multiple Multi select enabled
 * @param error FieldError object
 * @param options Select options properties
 * @param disabled Is field disabled
 * @param onChange Field change handler
 * @param defaultValue
 * @constructor
 */
export const Select: React.FC<SelectProps> = ({
    flex = 1,
    name,
    title,
    disableMargin = false,
    hasEmptyOption,
    multiple = false,
    error,
    options,
    disabled,
    onChange: onOptionChange,
    defaultValue = "",
}) => {
    const { control } = useFormContext();
    // eslint-disable-next-line
    const handleChange = (onChange: (...event: any[]) => void, value: any) => {
        if (!onOptionChange) {
            return onChange(value);
        }

        onOptionChange(onChange, value);
    };

    return (
        <FormControl flex={flex} disableMargin={disableMargin} error={!!error}>
            <InputLabel shrink id={`${name}`}>
                {title}
            </InputLabel>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                render={({ onChange, value }) => {
                    return (
                        <MuiSelect
                            value={value}
                            onChange={(option) => handleChange(onChange, option)}
                            error={!!error}
                            labelId={name}
                            id={name}
                            label={title}
                            multiple={multiple}
                            disabled={disabled}
                            displayEmpty={hasEmptyOption}
                            MenuProps={{
                                getContentAnchorEl: null,
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                },
                            }}>
                            {hasEmptyOption && (
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                            )}
                            {options.map((option, index) => {
                                return (
                                    // For some reason material ui is not handling well boolean values
                                    <MenuItem key={index} value={option.value}>
                                        {option.name}
                                    </MenuItem>
                                );
                            })}
                        </MuiSelect>
                    );
                }}
            />
            {error && <FormHelperText error={true}>{error?.message}</FormHelperText>}
        </FormControl>
    );
};
